module.exports = __webpack_public_path__ + "img/mitrex_logo_sm.c0efe847.png";